<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
          <strong>Made with</strong> ❤️ by <a href="http://vinayak.website" target="_blank">Vinayak</a>. The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
        </p>
        <p>
          <a class="icon" href="https://github.com/vinayakkulkarni/poll">
            <i class="fa fa-github"></i>
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?a52bdd56